import Enumeration from '@enums/enum';

/**
 * The supported expense resources.
 */
export const ExpenseEnum = new Enumeration({
  GENERAL: 'Resources::Expense::General',
  RENT: 'Resources::Expense::Rent',
});

/**
 * The supported income resources.
 */
export const IncomeEnum = new Enumeration({
  CENTRELINK: 'Resources::Income::Centrelink',
  DIVIDEND: 'Resources::Income::Dividend',
  EMPLOYED: 'Resources::Income::Employed',
  INTEREST: 'Resources::Income::Interest',
  OTHER: 'Resources::Income::Other',
  RENTAL: 'Resources::Income::Rental',
  SELF_EMPLOYED: 'Resources::Income::SelfEmployed',
  SUPERANNUATION: 'Resources::Income::Superannuation',
  EMPLOYMENT_STATUS: 'Resources::Income::EmploymentStatus',
});

/**
 * The supported resource types.
 */
export default new Enumeration({
  ...ExpenseEnum,
  ...IncomeEnum,
});
